import { Box, Image, Link, Text } from "@chakra-ui/react";
import { getCurrentColor } from "../../constants";

const MembershipFlag = ({
  colorMode,
  membership,
  membership_img_lt,
  membership_img_dk,
  membership_url,
}) => {
  return (
    <>
      <Box
        bg={getCurrentColor(colorMode, "blueC.100", "grayC.3800")}
        px={4}
        py={2}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        borderTopRadius={"6px"}
      >
        <Text
          fontSize="sm"
          fontWeight="bold"
          color={getCurrentColor(colorMode, "whiteC.100", "whiteC.100")}
        >
          {membership}
        </Text>
        <Link href={membership_url} target="_blank">
          <Image
            src={getCurrentColor(
              colorMode,
              membership_img_lt,
              membership_img_dk,
            )}
            alt="Ammo Plus Logo"
            width={"80px"}
            height={"30px"}
            objectFit="contain"
          />
        </Link>
      </Box>
    </>
  );
};

export default MembershipFlag;
